import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";

import "./Navbar.css";
function Navbar() {
  const [click, setClick] = useState(false);
  const [, setButton] = useState(true);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
          Cristal Inox
        </Link>
        <div className="menu-icon" onClick={handleClick}>
          {click ? <FiX /> : <FiMenu />}
        </div>
        <ul className={click ? "nav-menu active" : "nav-menu"}>
          <li className="nav-item">
            <NavLink to="/" end className="nav-links" onClick={closeMobileMenu}>
              Accueil
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/about" className="nav-links" onClick={closeMobileMenu}>
              À propos
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/catalogue" className="nav-links" onClick={closeMobileMenu}>
              Catalogue
            </NavLink>
          </li>
          <li>
            <Link to="/contact" className="nav-links btn--outline" onClick={closeMobileMenu}>
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
